const modules = import.meta.glob<{ default: string }>('./drnovska-*.jpg', { eager: true });

export const drnovskaImages = Object.keys(modules)
  .sort((a, b) => {
    const na = parseInt(a.match(/drnovska-(\d+)/)?.[1] || '0');
    const nb = parseInt(b.match(/drnovska-(\d+)/)?.[1] || '0');
    return na - nb;
  })
  .map(k => modules[k].default);
